import { connect } from 'react-redux';
import qs from 'qs';
import { ItemType } from '../../../../constants/inventory/InventoryTypes';
import { createInventoryItem } from '../../../../redux/Inventory/sagas/item/routines';
import CreateInventoryItem from '../index';

function mapStateToProps(state, props) {
  return {
    ...props,
    type: ItemType
  };
}

function mapDispatchToProps(dispatch, { location: { search } }) {
  const { sku } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    onInit: () => {},
    onSubmit: body => {
      dispatch(createInventoryItem({ ...body, sku }));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateInventoryItem);
